<template>
  <div>
    <div class="crm-export">
      <div class="crm-label">Export to CRM</div>
      <div class="crm-list">
        <div
          v-if="isNotHpeUser()"
          class="crm-box outreach"
          title="Outreach"
          @click="redirectToExport('Outreach')"
        >
          <img src="@/assets/icons/png/crm/Outreach.png" />
        </div>
        <!-- <Add-To-SalesForce
          :class="'crm-box salesforce'"
          :trigger="false"
          :userEmail="userEmail"
          :contactId="contactId"
          v-on:salesForceSuccess="salesForceSuccess"
          :pageType="pageType"
          :showActivationPopup="showActivationPopup"
        /> -->
        <div
          class="crm-box hubspot"
          title="Hubspot"
          @click="redirectToExport('Hubspot')"
        >
          <img src="@/assets/icons/png/crm/Hubspot.png" />
        </div>
        <Add-To-Salesgear
          v-if="this.isSalesgearExportEnabled"
          :class="'crm-box salesforce'"
          :trigger="false"
          :contactData="contactData"
          :pageType="pageType"
          :showSalesgearIcon="true"
          :showSequenceIcon="false"
          :showExportBannerBtn="false"
          :companyData="companyData"
          :showActivationPopup="showActivationPopup"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AddToSalesForce from '@/components/AddToSalesForce'
import AddToSalesgear from '@/components/crmExport/salesgear/AddToSalesgear'
import { get } from '@/assets/util/rest'
import { MxEvent } from '@/assets/util/constants/analytics'
import sharedFunctions from '@/assets/util/functions'
import { HP_DOMAIN_URL } from '@/assets/util/constants/constants'
import {
  TRIGGERS_TRACK_TO_LB,
  myLeadsUrl
} from '../../assets/util/constants/constants'

export default {
  name: 'CRM-Export',
  props: [
    'userEmail',
    'contactId',
    'pageType',
    'contactData',
    'companyData',
    'showActivationPopup'
  ],
  data: function() {
    return {
      redirectUrl: '',
      isSalesgearExportEnabled: this.$store.state.salesgear
        .showSalesgearExportOption,
      email: this.$store.state.header.email
    }
  },
  components: {
    'Add-To-SalesForce': AddToSalesForce,
    'Add-To-Salesgear': AddToSalesgear
  },
  computed: {
    salesgearBanner() {
      return this.$store.state.salesgear.salesgearBanner
    },
    loggedInEmail() {
      return this.$store.state.header.email
    },
    isAccountVerified: function() {
      return this.$store.state.header.emailStatus == 0
    },
    listId() {
      return this.$store.state.linkedin.list.selectedListId
    },
    listName() {
      return this.$store.state.linkedin.list.selectedList
    }
  },
  methods: {
    salesForceSuccess(res) {
      console.log('salesForceSuccess ', res)
    },
    salesgearSuccess(res) {
      console.log('salesForceSuccess ', res)
    },
    redirectToExport(type) {
      if (!this.isAccountVerified) {
        this.showActivationPopup()
      } else {
        if (this.pageType === 'single' || this.pageType === 'domain') {
          if (this.$store.state.isCRMExportEnabled) {
            sharedFunctions.track(
              MxEvent.crmRedirect,
              { exportType: type, pageType: this.pageType },
              this.$store.state
            )
            window.open(
              `${myLeadsUrl(
                this.listId,
                TRIGGERS_TRACK_TO_LB.EXPORT_CONTACT
              )}&apExportType=${type}`
            )
          } else {
            this.$emit('crmUpgradePopup', type)
          }
        } else {
          sharedFunctions.track(
            MxEvent.crmRedirect,
            { exportType: type, pageType: 'Bulk' },
            this.$store.state
          )
          window.open(
            `${myLeadsUrl(
              this.listId,
              TRIGGERS_TRACK_TO_LB.EXPORT_CONTACT
            )}&apExportType=${type}`
          )
        }
      }
    },
    isNotHpeUser() {
      if (this.loggedInEmail) {
        return sharedFunctions.checkEmailDomain(
          this.loggedInEmail,
          HP_DOMAIN_URL
        )
      }
      return true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.crm-export {
  display: flex;
  padding: 10px 0;
  flex-direction: column;
  .crm-label {
    font-size: 14px;
    line-height: 24px;
    color: #667080;
  }
  .crm-list::v-deep {
    display: flex;
    margin-top: 8px;
    .crm-box {
      height: fit-content;
      display: flex;
      align-items: center;
      cursor: pointer;
      justify-content: center;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      border: 1px solid rgba(102, 112, 128, 0.1);
      background: #ffffff;
      border-radius: 50%;
      padding: 8px;

      &:hover {
        border: 1px solid $primary-color;
      }

      &:not(:last-child) {
        margin-right: 12px;
      }
      img {
        max-height: 100%;
        vertical-align: middle;
        max-width: 100%;
      }
      &:hover img {
        animation: MoveUpDown linear 1000ms 3;
      }
      &.outreach {
        color: #5951ff;
      }
      &.salesforce {
        color: #199cdb;
      }
      &.hubspot {
        color: #ff7a59;
      }
    }
  }
}
</style>
